<template>
  <div class="same-day-option">
    <div class="same-day-option--wrapper">
      <p class="same-day-option--title">お預かり日当日の配達が可能！</p>
      <p class="same-day-option--description">
        ご希望の場合は下記をチェックしてください。
      </p>
      <p class="same-day-option--check bold">
        <label class="cursor-pointer hover-fade">
          <input
            type="checkbox"
            @change="
              (event) => toggleSameDayPickupAndDeliveryUse(!!event.target?.checked)
            "
          />
          お預かり日当日の配達を希望する (+¥{{
            sameDayPickupAndDeliveryPrice.toLocaleString()
          }})
        </label>
      </p>
      <p class="same-day-option--description">
        ※18時までの事前予約で最短翌々日のお預かり・配達が可能です。
      </p>
      <p class="same-day-option--description">
        詳細は<a
          href="https://www.008008.jp/faq/?ul_q=&ul_select_id=deaf51ddff1d&ul_select_sid=7329193"
          target="_blank"
          rel="noopener"
          >こちら</a
        >をご覧ください。
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontService'
import { $yhcGA4EventSender } from '../../YhcGA4EventSender'

export default {
  name: 'YhcEFSameDayDeliveryOption',
  inject: ['YhcEstimateFormFrontServiceInstance'],
  data() {
    return {
      canSelectTimeOptionFrom: false,
      canSelectTimeOptionTo: false,
    }
  },
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
    sameDayPickupAndDeliveryPrice(): number {
      return this.$yhcefs.generalOptionsByKey['same_day_delivery'].price
    },
  },
  mounted() {
    // マウント時に自発着可能エリアであることをGA4へ送信する
    $yhcGA4EventSender.sameDayDeliveryAvailable(
      this.$yhcefs.$userInputData.zip_from,
      this.$yhcefs.$userInputData.zip_to,
    )
  },
  methods: {
    toggleSameDayPickupAndDeliveryUse(checked) {
      this.$yhcefs.$userInputData.sameDayPickupAndDeliveryUseChange(checked)
      if (checked) {
        // GA4へイベント送信
        $yhcGA4EventSender.checkOnSameDayDelivery()
      }
    },
  },
}
</script>

<style lang="scss">
.same-day-option {
  padding: 0 var(--yhc-pad);
  margin-bottom: 10px;

  .same-day-option--wrapper {
    padding: 10px;
    background-color: #f0f8ff; // 薄い青色の背景
    border: 2px solid var(--yhc-color);
    border-radius: 8px;
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);

    .same-day-option--title {
      font-size: 18px;
      font-weight: bold;
      color: var(--yhc-color);
      margin-bottom: 8px;
    }

    .same-day-option--description {
      font-size: 14px;
      line-height: 1.4;
      margin-bottom: 10px;

      .highlight {
        font-weight: bold;
        color: #ff4500; // 目立つ色（オレンジレッド）
      }
    }
  }
}
</style>
